// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/intelligentDocumentIndex.css
// module id = 351
// module chunks = 1